// GENERATED — pre-signed public board defs, admin key discarded.
// NSFW seed board removed; uploads on public boards are disabled client-side.
import type { NostrEvent } from 'nostr-tools';

export const SEED_EVENTS: NostrEvent[] = [
  {
    "kind": 34553,
    "created_at": 1788813220,
    "tags": [
      [
        "d",
        "09e7dd1be75c6fb0e6e75d259bf4dc126580f0d79282b5fafae72ae076297f2a"
      ],
      [
        "alt",
        "Encrypted board metadata (relatos)"
      ],
      [
        "t",
        "relatos-public"
      ],
      [
        "key",
        "7446e6c820df3f2ba75ba43d7acaa935fd365c7024e2c896a1b61efa8fdcb954"
      ]
    ],
    "content": "AjMuqJyLWC1zcUo2/6pWaZwGkv9huXnnKehpJe2e7zQvDEABtKgBdbagXzfQc6NOeHJmxhP3+0IqyqRbeXYy49VcrAW16evx+4IuWLTasQ5DCmwJd2s6+Jk/NoqCgSqTf9NKpvfcc/XiHglquItLAfaqceObZie3kJ5o3Kyy2muq6jer2bRmmP2zchDIhPV/xJ1VCfffT5f2bqcdiHtNek55xjxZktDpnL3+/RgWb6/0UjE8d5EJjwXyNvUt3yqnV9597aYPA2kPH/hCJtur1+n0c6RlKxWouSXchZpRlU6bjAm0sTAWlN9Z9C+BsOc2ZTGNZbL2Zil2EoG049MmTynN9gxNKXv+EqpyLu9jyTjtFGhUCS86YSNbtLIEBlJuRd3S",
    "pubkey": "6335366ac53a0f1fadb7a7feabc11c2dc117264817101c2034e3d28ac062dbf2",
    "id": "31a96062fb218271ffe28deb17ffce7b29b35548bb13e013d2b2e0fa603582d8",
    "sig": "89a21c82f39f66d46fd2df8d730d44bce64b8e0c8b037272da0080b26df236bcd689b77b9f0bde1f02d08e10d4d581d7975ffc0ff5091adeb642d01abeb22222"
  },
  {
    "kind": 34553,
    "created_at": 1788813220,
    "tags": [
      [
        "d",
        "28dbb2eab6ab78d33b6ecda0e302c50eff5d0b05b28f46e4ac25a69768a79d78"
      ],
      [
        "alt",
        "Encrypted board metadata (relatos)"
      ],
      [
        "t",
        "relatos-public"
      ],
      [
        "key",
        "3c82941c3bc0014484c9beb39ed923e9ff530d1f05a2eeafbe48848644a6416b"
      ]
    ],
    "content": "AmqYnJW/sVkdqe/Kz1XneZzR4CEuvoGPoOJHBPysmsDd3Gc4SwpW9VnM1B/MiHXS2/ZUwIrTGERV4lwIouWFHQ9MxwYZcZ1Ho3UVsCMDkgpaZxsXaVuKMKROF9QUZ8T1at7DrUtGOQ/E6NO57DjluPrEZJHx0kSm7K7U6FmY9Lh9jjwZ1j2swEQ/urfbuf6/nAD1RigVww0U4F+bb3RjkOOvC1rvAlcPHwTxoxYhuwAFGPFkcy9VXvZTbLhuXNRnlR4/m969nhngUcAszxeZCT+Py7HYmT8847a8DOozGhwsjt61d5LDBgGx9BK/SfZhaTrqyWAkUczjYy6s/+cNB6liPVUIElm9p3sCnjecDZzEyvb+XYD9DIZMf6apNqAgMN6K",
    "pubkey": "6335366ac53a0f1fadb7a7feabc11c2dc117264817101c2034e3d28ac062dbf2",
    "id": "cd6951fa9c2711be805a2fbcd40ab4fd074ee7e853282246ad25e91fd2431924",
    "sig": "3c30eecd65a812a543de5db4562b2a552743bd0a4b606bd3260c540c298b975c10648263c4f7df2cb95a9687b19e06f194f9ca940b3958c3a22a8d3d757fff85"
  },
  {
    "kind": 34553,
    "created_at": 1788813220,
    "tags": [
      [
        "d",
        "deb6fffc3cbc843fc412baf442636b06c542ee3646c537390f62fc25e3d214b3"
      ],
      [
        "alt",
        "Encrypted board metadata (relatos)"
      ],
      [
        "t",
        "relatos-public"
      ],
      [
        "key",
        "c1bdf2fddaeea2ca5080f8cecf4aa1bf3c163f90cbe51c76943c16ee27894736"
      ]
    ],
    "content": "AnpVuEnZJC+5yBARFloYZUQxi0wpba4W3VeKx2KxDukK+RjEWaiWv0wNf+JbZ4Svs+CUINKujoteKi8vcmpftNMDCWJSuriKMwLPxFFDTDJ5pryRzEF9vqXZPhjgN0qhlZc2Z/1ocvTjbCdrEPv9sXpnZHk4sOjB7+4ZGzi5TctyedO0+g1uL5AOU8ksnf1LbP/jRWyt9ilXt8q/z4m01vEd7CVhxCD6ZwaLfyIQIOaEyo17V3eSIk/cOAegWfNV0r5JfkxkXLcUJYk9ReUbpnvUCKdQrgSa0/yd/OfX3CwClIuYHn6HzwyR/NOFnohgVB3BRpeOAooUFFwcXSbFPOszD7JFOucs99UZ0SliYX3BxwTRA/nhDBMAcs7yypsj7V17",
    "pubkey": "6335366ac53a0f1fadb7a7feabc11c2dc117264817101c2034e3d28ac062dbf2",
    "id": "d44f6d8ebe91ae5fba24210bf6525adbe00f286f4d83f2a267dfe0cedf41a14e",
    "sig": "706e26313aeb2bbab0c6ea11b9643cf475b134d9747f887d29f389c0c5db0d320b24a5e2e1e39a7d2db92835f17db33be5ec20125d34bf82254fa2ecf75b5bb8"
  },
  {
    "kind": 34553,
    "created_at": 1788813220,
    "tags": [
      [
        "d",
        "c8c19c4fafd4c64f095a13a1a4fc22e7c6879acc5a36b9a5b3be25c8bd589da6"
      ],
      [
        "alt",
        "Encrypted board metadata (relatos)"
      ],
      [
        "t",
        "relatos-public"
      ],
      [
        "key",
        "3e71c77c53cee4e56f1a10a0ecc301d12916f51d4058c22f42b2585a78cf37ba"
      ]
    ],
    "content": "AnV+8y0X5n4OGRvXPvdCsozqzartR6xsRXlenH1iQmId2xWZnRg/4Xn3XqisSJWrK8DA5orxbahJrBDBNxsc6qn+6v3i4w6o8hhlqHnYBNLr0AtVCGRU2KL+2zUGncPmwo5Duki5getYJBJ3ew+YL3SjGYvWOz+IJHmUJJDhssJJAtBSe0aJLWAOGcQ+9+q1oa6ul2ReDUxkEO4eQn9RpYymDFJ23NpvjrB4liK8tzJ3Ut4iZtMgBy0opio6InlAWo242RFNVLP9QLcTM+1RPiGTz28oxEVAK4TuDfQgga4mbfVpwqnidH2zTM+Erwr/6BVWfId7m0Fk82BOx5tDoG6gFJxD9Fg6IZq2WK7majJeH2Iy5v3RwdDi+Iz9eFBT4K50v+mCvvP8yoKwggUm5Y3FjovizHSibeE4PRnWFmfAVTc=",
    "pubkey": "6335366ac53a0f1fadb7a7feabc11c2dc117264817101c2034e3d28ac062dbf2",
    "id": "81284985eb0a39cbcd8a1a852523aa1527e09e282f61843f52bbdea381cce4bb",
    "sig": "b2108ca27bbac386eac3eecd1da2031dcf0f90ef5e2d56865cf4fc7b88e6075cfa74f891f5bab821360de3c4a010f169e81286bbaeeac0cfa984e7c0ff491692"
  },
  {
    "kind": 34553,
    "created_at": 1788813220,
    "tags": [
      [
        "d",
        "56d92243489047cc57c72f1ae5c0ca84336c8d91a07f85a2e72f2c966dd5da9d"
      ],
      [
        "alt",
        "Encrypted board metadata (relatos)"
      ],
      [
        "t",
        "relatos-public"
      ],
      [
        "key",
        "c75a8afcdde30d116a52b27ab2c4196ed16ec51ddea76b5b9ae1e8def2ce27cc"
      ]
    ],
    "content": "AkvnSsuooCRWQzn0mHLICOsXnm6iD4RuaPPdewQEiA9Cp05QQr00NpViYidiprj1hpwZ6l6lQBofJ+uafpK3oOxdRTszEaqp4nw8+qOAXJJPm5iWOw9EZ3TktVEYzqBPv1SFN5/iyIqsRP8kUtZhA/gIYoiUbe0/4D3/9EsWnc6RxEtEzqVPs6qEAIn6zq7LxcBklBMf4v5pTLvYJVdLFeZeEqiF1W78/F1NeOaEwP/9/E8ifPwsc8yWwQBPHcC5Yfw87PAfm/jjs/efTsN2psenWGXztjsIS4V9LFlR2AW5elmiLEpoIqVbeO/uWjikXEMLCBSA+0QPpRn/R43yXf7bT5Anyyep4hTZjlhg/pjZ9SfP69Ft+FqyPVUayW9ygNjR",
    "pubkey": "6335366ac53a0f1fadb7a7feabc11c2dc117264817101c2034e3d28ac062dbf2",
    "id": "8eeb8e319551977a32c713248a6dd755d03f0f89e61d31077e2a38f24b40d8a9",
    "sig": "5edc3343059f42dd26d7f6ccddc88071c2856257d9abe75f2c7efba794ee58cac7a4132a53a24c3cc07b96acd5c95069d51b98ff25ed03c195dc7262377d0ddb"
  }
];
